(function () {
    $(document).ready(function () {
        $(".split-slider").slick({
            slidesToShow: 1,
            arrows: false,
            dots: true,
            appendDots: ".slide-dots",
            adaptiveHeight: true,
            draggable: true,
            asNavFor: ".split-slider__controls",
        });

        $(".split-slider__controls").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            variableWidth: true,
            arrows: false,
            asNavFor: ".split-slider",
            draggable: true,
            swipeToSlide: true,
            touchThreshold: 10,
        });

        if ($(".split-slider").length) {
            // Find the parent div with the class band and add a new class to it
            $(".split-slider").closest(".band").addClass("band--split-slider");
        }
    });
})(this);
